export class FinanceCalculatorModule {
    constructor() {
        this.init();
    }

    humanizeNumber(nStr) {
        nStr += '';
        var x = nStr.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;

        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }

        if (x2 > 0)
            return x1 + x2;
        else
            return x1;
    }

    formattedCurrency(n) {
        return '£' + this.humanizeNumber(parseFloat(n).toFixed(2));
    }

    updateChart(el, intLoanAmountPercent, intTotalMonthlyPayment, interestPercent) {
        
        intLoanAmountPercent = Math.round(intLoanAmountPercent);
        interestPercent = Math.round(interestPercent);

        if (intLoanAmountPercent > 100) {
            intLoanAmountPercent = 100;
        } else if (intLoanAmountPercent < 0) {
            intLoanAmountPercent = 0;
        }
        var decLoanAmountDeg = Math.round(360 * (intLoanAmountPercent / 100));       

        if (interestPercent > 100) {
            interestPercent = 100;
        } else if (interestPercent < 0) {
            interestPercent = 0;
        }
        var interestDeg = Math.round(360 * (interestPercent / 100));

        
        if (intLoanAmountPercent > 50) {
            $(el + ' .pie').css('clip', 'rect(auto, auto, auto, auto)');
            $(el + ' .pie .right-side').css('transform', 'rotate(180deg)');

        } else {
            $(el + ' .pie').css('clip', 'rect(0, 1em, 1em, 0.5em)');
            $(el + ' .pie .right-side').css('transform', 'rotate(0deg)');
        }


        if (interestPercent > 50) {
            $(el + ' .interest').css('clip', 'rect(auto, auto, auto, auto)');
            $(el + ' .interest .right-side').css('transform', 'rotate(180deg)');

        } else {
            $(el + ' .interest').css('clip', 'rect(0, 1em, 1em, 0.5em)');
            $(el + ' .interest .right-side').css('transform', 'rotate(0deg)');
        }


        $(el + ' .pie .left-side').css('transform', 'rotate(' + decLoanAmountDeg + 'deg)');
        $(el + ' .interest .left-side').css('transform', 'rotate(' + interestDeg + 'deg)');


        $(el + ' .shadow').css('border-width', '0.077em');
        $(el + ' .num').text('Monthly payments');
        $(el + ' .smaller').text(this.formattedCurrency(intTotalMonthlyPayment));

    }

    animateUpdateChart(el, intLoanAmountPercent, intTotalMonthlyPayment, interestPercent, currentTotalPercent, currentRepayAmount, currentInterestPercent) {

        if (currentTotalPercent < intLoanAmountPercent) {

            this.updateChart(el, currentTotalPercent, currentRepayAmount, currentInterestPercent)

            currentTotalPercent++;
            currentRepayAmount = intTotalMonthlyPayment / intLoanAmountPercent * currentTotalPercent;
            currentInterestPercent += interestPercent / intLoanAmountPercent;

            let that = this;
            setTimeout(function () { 
                that.animateUpdateChart(el, intLoanAmountPercent, intTotalMonthlyPayment, interestPercent, currentTotalPercent, currentRepayAmount, currentInterestPercent);
            }, 5)
        }
        else {
            this.updateChart(el, intLoanAmountPercent, intTotalMonthlyPayment, interestPercent)
        }
    }

    calculateFinance(intPrice, intDeposit, intLoanTermInMonths, fnDone, fnFail) {

        var calculateFinanceArguments = { price: intPrice, deposit: intDeposit, loanTermInMonths: intLoanTermInMonths};

        $.ajax({
            type: "GET",
            url: apilocation + "FinanceCalculatorApi/CalculateFinance",//"?price=2000&deposit=200&loanTermInMonths=12",
            data: calculateFinanceArguments,
            contentType: false
        }).done(function (data) {
            var decApr = data.APR;
            var intLoanValue = data.LoanValue;
            var decTotalInterestPayable = data.TotalInterestPayable;
            var intLoanTermInMonths = data.Term;
            var intDepositAmount = data.Deposit;
            var strRateCardProductId = data.RateCardProductId;
            fnDone(decApr, intLoanValue, decTotalInterestPayable, intLoanTermInMonths, intDepositAmount, strRateCardProductId);
        }).fail(function (XMLHttpRequest, textStatus, errorThrown) {
            fnFail(textStatus);            
        }).always(function () {
        });
    }

    updateQuote(fnDone, fnFail) {

        var that = this;

        // get the treatment price from the input, this may be read only or filled in by user
        var treatmentPrice = $("#treatmentPrice").val().replace(/[£,]+/g, "");
        var treatmentPriceValue = Number(treatmentPrice.replace(/[^0-9\.]+/g, ""));
        
        var depositAmount = $('#depositAmountSlider').val();
        var intLoanPeriod = this.getLoanPeriodInMonths($('#loanPeriodSlider'));

        var intDeposit = parseInt(depositAmount, 10);
        if (isNaN(intDeposit)) {
            return; // TODO - Handle properly
        }

        //console.log("Loan period amount", intLoanPeriod);
            
        var onDone = function (apr, intLoanAmount, decTotalInterestPayable, intLoanTermInMonths, intDepositAmount, strRateCardProductId) {
            var loanAmountFormatted = that.formattedCurrency(intLoanAmount);
            var depositAmountFormatted = that.formattedCurrency(intDepositAmount);
            var loanPeriodFormatted = intLoanPeriod + ' months';
            var aprFormatted = apr.toFixed(2) + '%';
            var decTotalRepayAmount = intLoanAmount + decTotalInterestPayable;
            var totalRepayAmountFormatted = that.formattedCurrency(decTotalRepayAmount);
            var totalRepayAmountPerMonthFormatted = that.formattedCurrency(decTotalRepayAmount / 12);
            var decTotalToRepayPlusDeposit = intDepositAmount + decTotalRepayAmount;
            var intTreatmentPrice = intLoanAmount + intDeposit;

            $('#totalAmountPerMonth').html(totalRepayAmountPerMonthFormatted);
            $('#totalAmount').html(totalRepayAmountFormatted);
            $('#rightPanelLoanAmount').html(loanAmountFormatted);
            $('#rightPanelDepositAmount').html(depositAmountFormatted);
            $('#rightPanelLoanPeriod').html(loanPeriodFormatted);
            $('#rightPanelAPR').html(aprFormatted);

            var decInterestPercent = decTotalInterestPayable / decTotalToRepayPlusDeposit * 100;
            
            // We need to include the interest here as well because the interest will
            // hide some of the loan amount's proportion
            var decLoanAmountPercent = parseFloat(intLoanAmount + decTotalInterestPayable) / decTotalToRepayPlusDeposit * 100;
            var decTotalMonthlyPayment = decTotalRepayAmount / intLoanTermInMonths;

            var strEligibilityLink = that.constructEligibilityLink(
                strRateCardProductId, intTreatmentPrice, intDepositAmount, that.strTreatmentCode, that.strTreatmentName, that.strHospitalName);
            that.$checkEligibilityButton.attr("href", strEligibilityLink);

            /*console.log("decTotalRepayAmount", decTotalRepayAmount)
            console.log("decLoanAmountPercent", decLoanAmountPercent);
            console.log("decTotalMonthlyPayment", decTotalMonthlyPayment);
            console.log("decInterestPercent", decInterestPercent);*/

            //animateUpdateChart(el, intLoanAmountPercent, intTotalMonthlyPayment, interestPercent, currentTotalPercent, currentRepayAmount, currentInterestPercent) {
            that.animateUpdateChart('#demo',
                decLoanAmountPercent,
                decTotalMonthlyPayment,
                decInterestPercent,
                0,
                0,
                0);

            that.clearErrorMessage();

            fnDone();                

        }

        var onFail = function(textStatus) {
            that.setErrorMessage("We're sorry but your finance could not be calculated at this time, please try again later.");
            fnFail();
        }
        
        /*
         * Go off and get the APR and total interest payable from Omni
         */
        this.calculateFinance(treatmentPriceValue, intDeposit, intLoanPeriod, onDone, onFail);

    }

    updateSlider(slider) {

        var min = $(slider).prop('min');
        var max = $(slider).prop('max');
        var val = $(slider).prop('value');
        //console.log('updateslider ' + val);
        var enforcedMin = $(slider).data('enforcedmin');
        //console.log(enforcedMin);

        if (enforcedMin) {
            if (val < enforcedMin) {
                val = enforcedMin;
                $(slider).val(val);
            }
        }
        //console.log("val is ", val, "enforced min is ", enforcedMin, "actual slider val is", $(slider).val());
        if (!this.supportsProgressTrack()) {
            var percent = ((val - min) / (max - min)) * 100.0;
            $(slider).css('background', 'linear-gradient(to right, #16ccbb 0%, #16ccbb ' + percent + '%, #cfcfcf ' + percent + '%, #cfcfcf 100%)');
        }                
    }

    setMonetaryScale($sliderInput, intNewMaximum) {
        var $wrapper = $sliderInput.closest(".slider-wrapper");
        var $dataLabels = $wrapper.find(".data-labels");
        var $rangeLabels = $dataLabels.find(".range-labels");
        var $rangeLabelsMobile = $dataLabels.find(".range-labels-mobile");

        // Desktop
        var intRangeCount = parseInt($rangeLabels.attr("data-rangeCount"), 10);
        var intScaleStep = Math.floor(intNewMaximum / intRangeCount);
        var strNewRangeLabels = "";        
        for (var i = 1; i <= intRangeCount; i++) {        
            strNewRangeLabels += "<li class=''>&nbsp;<span>£"
                +  (i === intRangeCount ? (intNewMaximum) : (i * intScaleStep))
                + "</span></li>";

        }
        $rangeLabels.html(strNewRangeLabels);    

        // For mobile we always set a range of 3
        const FIXED_MOBILE_RANGE_COUNT = 2;
        var intScaleStepMobile = Math.floor(intNewMaximum / FIXED_MOBILE_RANGE_COUNT);
        var strNewRangeLabelsMobile = "";        
        for (var i = 1; i <= FIXED_MOBILE_RANGE_COUNT; i++) {
            strNewRangeLabelsMobile += "<li class=''>&nbsp;<span>£"
                +  (i === FIXED_MOBILE_RANGE_COUNT ? (intNewMaximum) : (i * intScaleStepMobile))
                + "</span></li>";
        }
        $rangeLabelsMobile.html(strNewRangeLabelsMobile);
    }

    getIntFromCurrencyInput($currencyInput) {

        if ($currencyInput.val() !== undefined) {
            var stringCurrencyInputValue = $currencyInput.val().replace(/[£,]+/g, "");
            var intCurrencyInputValue = parseInt(stringCurrencyInputValue.replace(/[^0-9\.]+/g, ""), 10);
            return intCurrencyInputValue;
        }
    }

    getMinimumValue($slider) {
        var enforcedMin = $slider.data('enforcedmin');
        return typeof(enforcedMin) === undefined ? $slider.prop("min") : enforcedMin;
    }

    updateSliderAndTextField($slider, fnFormatter) {
        this.updateSlider($slider[0]);
        var loanAmountFormatted =  fnFormatter($slider.val());// this.formattedCurrency($slider.val());
        var $totalField = $slider.closest(".dataItem").find(".inlineTotal input");        
        $totalField.val(loanAmountFormatted);
    }

    formatAsMonths(strValue) {
        return strValue + ' months';
    }

    calculateSliderLimits(intTreatmentPrice) {
        const MinDepositProportion = 0.1; // 0 -> 1.0
        const MaxDepositProportion = 0.5; // 0 -> 1.0
        const MinLoanAmount = 1000;
        const MaxLoanAmount = 25000;
    
        // We need to use ceil because the Omni API doesn't support fractional amounts, but enforces fractional business rules
        var depositSliderMin = Math.ceil(Math.max(intTreatmentPrice * MinDepositProportion, intTreatmentPrice - MaxLoanAmount));
        
        var depositSliderMax = Math.floor(Math.min(intTreatmentPrice * MaxDepositProportion, intTreatmentPrice - MinLoanAmount));
    
        var loanAmountSliderMin = Math.max(MinLoanAmount, intTreatmentPrice - depositSliderMax);
        var loanAmountSliderMax = Math.min(MaxLoanAmount, intTreatmentPrice - depositSliderMin);

        //debugger;

        if (depositSliderMin > depositSliderMax || loanAmountSliderMin > loanAmountSliderMax
            || isNaN(depositSliderMin) || isNaN(depositSliderMax) || isNaN(loanAmountSliderMin) || isNaN(loanAmountSliderMax)) {
            return null;
        }
        else {
            return { depositMin: depositSliderMin, depositMax: depositSliderMax, loanAmountMin: loanAmountSliderMin, loanAmountMax: loanAmountSliderMax };
        }        
    }

    getLoanPeriodInMonths($loanPeriodSlider) {
        var customScale = $loanPeriodSlider.data("customscale");        
        var intStepVal = parseInt($loanPeriodSlider.val(), 10);
        var mappedValue = customScale[intStepVal - 1];
        return mappedValue;
    }

    disableAllButPrice() {
        this.$loanAmountSlider.attr("disabled", "disabled");
        this.$depositSlider.attr("disabled", "disabled");
        this.$loanPeriodSlider.attr("disabled", "disabled");
        this.$updateQuote.attr("disabled", "disabled");
        this.$checkEligibilityButton.attr("href", null);
    }

    disableUserInput() {                
        this.disableAllButPrice();
        this.$treatmentPriceInput.attr("disabled", "disabled");        
    }

    enableUserInput() {
        this.$treatmentPriceInput.attr("disabled", null);
        this.$loanAmountSlider.attr("disabled", null);
        this.$depositSlider.attr("disabled", null);
        this.$loanPeriodSlider.attr("disabled", null);
        this.$updateQuote.attr("disabled", null);
    }

    setErrorMessage(strErrorMessage) {
        this.$errorContainer.text(strErrorMessage);
    }

    clearErrorMessage() {
        this.$errorContainer.text("");
    }

    hasValidPrice() {
        var intTreatmentPrice = this.getIntFromCurrencyInput(this.$treatmentPriceInput);
        return this.calculateSliderLimits(intTreatmentPrice) !== null;
    }

    priceIsBlank() {
        var intTreatmentPrice = this.getIntFromCurrencyInput(this.$treatmentPriceInput);
        return isNaN(intTreatmentPrice);
    }

    isInternetExplorer() {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf('MSIE ');
        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./) || navigator.userAgent.match(/Edge\/\d+/)) {
            return true;
        } else {
            return false;
        }
    }

    isWebKit() {
        var isWebkit = /WebKit/.test(navigator.userAgent);
        return isWebkit;
    }

    supportsProgressTrack() {
        return !this.isWebKit();
    }

    supportsSliderInputEvents() {
        return !this.isInternetExplorer();
    }    

    constructEligibilityLink(strRateCardProductId, intTreatmentPrice, intDepositAmount, strTreatmentCode, strTreatmentName, strHospitalName) {
        var returnValue = this.strEligibilityPageUrl;
        returnValue += ("?rateCardProductId=" + strRateCardProductId
            + "&treatmentPrice=" + intTreatmentPrice
            + "&depositAmount=" + intDepositAmount
            + "&treatmentCode=" + strTreatmentCode
            + "&treatmentName=" + strTreatmentName
            + "&hospitalName=" + strHospitalName);
        return returnValue;
    }

    init() {

        const DEFAULT_LOAN_AMOUNT_MAX = 9000;
        const DEFAULT_LOAN_AMOUNT_MIN = 0;
        const DEFAULT_DEPOSIT_AMOUNT_MAX = 4500;
        const DEFAULT_DEPOSIT_AMOUNT_MIN = 0;

        var that = this;
        
        var $treatmentPriceInput = $('#treatmentPrice');
        var $loanAmountSlider = $('#loanAmountSlider');
        var $depositSlider = $('#depositAmountSlider');
        var $loanPeriodSlider = $('#loanPeriodSlider');
        var $updateQuote = $('#updateQuote');
        

        // TODO - Use these instead
        this.$treatmentPriceInput = $treatmentPriceInput;
        this.$loanAmountSlider = $loanAmountSlider;
        this.$depositSlider = $depositSlider;
        this.$loanPeriodSlider = $loanPeriodSlider;  
        this.$updateQuote = $updateQuote;
        this.$calculatorContainer = $(".finance-calculator");
        this.$errorContainer = this.$calculatorContainer.find(".error");
        this.$checkEligibilityButton = this.$calculatorContainer.find("#check-eligibility");
        this.strTreatmentCode = this.$calculatorContainer.data("treatment-code");
        this.strTreatmentName = this.$calculatorContainer.data("treatment-name");
        this.strHospitalName = this.$calculatorContainer.data("hospital-name");
        this.strEligibilityPageUrl = this.$checkEligibilityButton.data("eligibility-url")
                
        if (!this.supportsProgressTrack()) {
            this.$calculatorContainer.find(".slider input").css('background', 'linear-gradient(to right, #16ccbb 0%, #16ccbb 0%, #cfcfcf 0%, #cfcfcf 100%)');
        }  

        this.disableUserInput();

        $(document).on('input', '#loanAmountSlider', function () {
            that.updateSliderAndTextField($(this), function(s) { return that.formattedCurrency(s); });

            // Synchronise deposit amount
            var intLoanAmountVal = $(this).val();
            var treatmentPrice = that.getIntFromCurrencyInput($treatmentPriceInput);
            var intDepositAmount = treatmentPrice - intLoanAmountVal;
            $depositSlider.val(intDepositAmount);
            that.updateSliderAndTextField($depositSlider, function(s) { return that.formattedCurrency(s); });
        });

        $(document).on('input', '#depositAmountSlider', function () {
            that.updateSliderAndTextField($(this), function(s) { return that.formattedCurrency(s); })
            
            // Synchronise loan amount
            var intDepositAmount = $(this).val();
            var treatmentPrice = that.getIntFromCurrencyInput($treatmentPriceInput);
            var intLoanAmount = treatmentPrice - intDepositAmount;
            $loanAmountSlider.val(intLoanAmount);
            that.updateSliderAndTextField($loanAmountSlider, function(s) { return that.formattedCurrency(s); });
        });

        $(document).on('input', '#loanPeriodSlider', function () {
            var $loanPeriodSlider = $(this);
            that.updateSliderAndTextField($loanPeriodSlider,
                function(s) {
                    var intLoanPeriod = that.getLoanPeriodInMonths($loanPeriodSlider);
                    return that.formatAsMonths(intLoanPeriod.toString());
                });
        });       

        $(document).on('input', '#treatmentPrice', function (x) {
            
            // Sanitise values to only include digits, then reformat as currency
            var $input = $(this); 
            var nonDigitRegex = /[^\d]/gi;
            var strCurrentVal = $input.val();
            var strSanitisedVal = strCurrentVal.replace(nonDigitRegex, '');
            $input.val(strSanitisedVal === '' ? '£' : that.formattedCurrency(strSanitisedVal));  
            var intTreatmentPrice = parseInt(strSanitisedVal, 10);            
            
            if (isNaN(intTreatmentPrice)) {
                intTreatmentPrice = 0;
            }          
   
            // Update the scale and min/max values of the sliders based on the treatment price                           
            var minMaxValues = that.calculateSliderLimits(intTreatmentPrice);

            var blnHasValidValues = minMaxValues !== null;
            
            //console.log("minMaxValues", minMaxValues);               

            // Loan amount maximum
            $loanAmountSlider.prop("max", blnHasValidValues ?  minMaxValues.loanAmountMax : DEFAULT_LOAN_AMOUNT_MAX);
            that.setMonetaryScale($loanAmountSlider, blnHasValidValues ? minMaxValues.loanAmountMax : DEFAULT_LOAN_AMOUNT_MAX);
            $loanAmountSlider.data("enforcedmin", blnHasValidValues ? minMaxValues.loanAmountMin : DEFAULT_LOAN_AMOUNT_MIN);
            $loanAmountSlider.val(blnHasValidValues ? minMaxValues.loanAmountMax : DEFAULT_DEPOSIT_AMOUNT_MIN);

            // Deposit maximum
            $depositSlider.prop("max", blnHasValidValues ? minMaxValues.depositMax : DEFAULT_DEPOSIT_AMOUNT_MAX);
            that.setMonetaryScale($depositSlider, blnHasValidValues ? minMaxValues.depositMax : DEFAULT_DEPOSIT_AMOUNT_MAX);
            $depositSlider.data("enforcedmin", blnHasValidValues ? minMaxValues.depositMin : DEFAULT_DEPOSIT_AMOUNT_MIN);                

            if (blnHasValidValues) {          
                // As soon as we hit a valid price remove and don't readd, this is for initial load only
                that.$calculatorContainer.removeClass("blank-price");
                
                // Force deposit to update value based on loan amount
                $loanAmountSlider.trigger("input");
                that.clearErrorMessage();
                that.enableUserInput();
            }
            else {
                that.setErrorMessage("You seem to have entered an invalid treatment price. Please try increasing it above.");
                that.disableAllButPrice();                    
                that.$depositSlider.val(DEFAULT_DEPOSIT_AMOUNT_MIN);
                that.updateSliderAndTextField(that.$loanAmountSlider, function(s) { return that.formattedCurrency(s); });  
                that.updateSliderAndTextField(that.$depositSlider, function(s) { return that.formattedCurrency(s); });
            }        

        });

        // TODO - Reconcile this and the validation code above
        $(document).on('blur', '#treatmentPrice', function (x) {
            //const intStep = 50;
            var $input = $(this); 
            var nonDigitRegex = /[^\d]/gi;
            var strCurrentVal = $input.val();
            var strSanitisedVal = strCurrentVal.replace(nonDigitRegex, '');
            var intVal = parseInt(strSanitisedVal, 10);   
            var intOriginalPrice = $input.data("originalprice");
            if (isNaN(intVal)) {      
                $input.val(that.formattedCurrency(intOriginalPrice + ''));
            }
            else {
                // Uncomment to round to a specific step value
                // var intRemainder = intVal % intStep;
                // if (intRemainder !== 0) {
                //     intVal = intVal - intRemainder;
                //     $input.val(that.formattedCurrency(intVal + ''));
                // }

                //var minMaxValues = that.calculateSliderLimits(intVal);
                //var blnHasValidValues = minMaxValues !== null;
                // if (!blnHasValidValues) {                    
                //     $input.val(that.formattedCurrency(intOriginalPrice + ''));
                // }
            }
            $input.trigger("input");
        });

        $(document).on('click', '#updateQuote', function () {
            that.disableUserInput();
            that.updateQuote(
                function() {
                    that.enableUserInput();
                }, 
                function() {
                    that.enableUserInput();
                }                
            );
        });

        if (this.isInternetExplorer()) {
            $(".slider input").on("change", function() {
                $(this).trigger("input");
            });
        }

        // slider - firefox
        var isFF = true;
        var addRule = (function (style) {
            var sheet = document.head.appendChild(style).sheet;
            return function (selector, css) {
                if (isFF) {
                    if (sheet.cssRules.length > 0) {
                        sheet.deleteRule(0);
                    }

                    try {
                        sheet.insertRule(selector + "{" + css + "}", 0);
                    } catch (ex) {
                        isFF = false;
                    }
                }
            };
        })(document.createElement("style"));

        this.$loanPeriodSlider.trigger("input");

        if (this.hasValidPrice()) {            
            $treatmentPriceInput.trigger("input");
            this.updateQuote(
                function() {
                    that.enableUserInput();
                },
                function() {
                    that.enableUserInput();
                }
            );    
        } else {
            
            if (!this.priceIsBlank()) {               
                this.$calculatorContainer.removeClass("blank-price");
            }

            this.enableUserInput();
            this.disableAllButPrice();
        }
    }

}
